import deleteData from "../services/deleteData";
import fetchData from "../services/fetchData";
import patchData from "../services/patchData";
import postData from "../services/postData";

const handleFetchServices = async ({ page, limit, status, params }: any) => {
  const uri = `v1/services?page=${page}&limit=${limit}&status=${status}&${params}`;
  const response = fetchData({ uri });
  return response;
};

const handleFetchService = async ({ _id }: any) => {
  const uri = `v1/services/${_id}`;
  const response = fetchData({ uri });
  return response;
};



const handleExportServices = async () => {
  const uri = `v1/services/export/all`;
  const response = fetchData({ uri });
  return response;
};

const handleCountServices = async ({ status }: any) => {
  const uri = `v1/services/count/all?status=${status}`;
  const response = fetchData({ uri });
  return response;
};

const handleCreateService = async (data: any) => {
  const uri = `v1/services`;
  const response = postData({ data, uri });
  return response;
};

const handleUpdateService = async ({ _id, data }: any) => {
  const uri = `v1/services/${_id}`;
  const response = patchData({ data, uri });
  return response;
};




const handleDeleteService = async ({ _id, data }: any) => {
  const uri = `v1/services/${_id}`;
  const response = deleteData({ data, uri });
  return response;
};

export {
  handleFetchServices,
  handleFetchService,
  handleExportServices,
  handleCreateService,
  handleUpdateService,
  handleDeleteService,
  handleCountServices,
};
